import React, { useEffect, Component } from 'react'
import { connect } from 'react-redux'
import { changeRoute } from 'store/actions/login'

export default function(ComposedComponent: React.FC) {
  class RequireAuth extends Component {
    componentWillMount() {
      if ((!this.props.authorized && !localStorage.getItem('auth_token')) && !localStorage.getItem('auth_token_verifyed')){
        this.props.history.push('/login')
      }
    }
    componentWillUpdate(nextProps) {
      if ((!nextProps.authorized && !localStorage.getItem('auth_token')) && !localStorage.getItem('auth_token_verifyed')){
        this.props.history.push('/login')
      }
    }
    render() {
      if ((!localStorage.getItem('auth_token')) && (!localStorage.getItem('auth_token_verifyed'))) {
        return <></>
      }
      return <ComposedComponent {...this.props} />
    }
  }
  const mapStateToProps = (state: any) => ({
    authorized: state.googleAuth.authorized,
    authorizedAsan: state.token.authorizedAsan
  })
  const mapDispatchToProps = { changeRoute }

  return connect(mapStateToProps, mapDispatchToProps)(RequireAuth)
}